var Presse = {
  init: function () {
    console.log('YOOOOO');
    $(".articles-grid").infiniteScroll({
      path: ".next-link",
      append: ".tease-presse",
      hideNav: ".pagination-block",
      button: ".btn-voir-plus",
      scrollThreshold: false,
      status: ".page-load-status",
      debug: true,
    });
  },
};

$(window).load(function () {
  if ($(".block-presse").length) {
    Presse.init();
  }
});
